<template>
    <Default-Layout>
        <div class="container profile">
            <div class="row" v-if="appDetail !== null">
                <div class="col-12">
                    <div class="prof_title">
                        <h4>
                            <span v-if="appDetail !== null">{{ appDetail.name }}</span>
                            {{ $t("lang.label_priv") }}
                        </h4>
                        <!--  <p>Create privileges for the management of your organizations.</p> -->
                    </div>
                    <div
                        class="card"
                        style="border-top: 4px solid #a1e0ae; position: relative"
                    >
                        <div class="icontri"></div>
                        <div
                            class="card-header d-flex align-items-center justify-content-between"
                        >
                            <div style="display: flex; align-items: center">
                                <span style="font-size: 20px"
                                    >{{ $t("lang.label_priv_for") }}
                                    <b v-if="userDetail !== null"
                                        >{{ userDetail.firstname }}
                                        {{ userDetail.lastname }}</b
                                    >
                                </span>
                                <span
                                    style="
                                        font-size: 14px;
                                        margin-left: 30px;
                                        position: relative;
                                        display: flex;
                                    "
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="selectAll"
                                        id="defaultCheckg"
                                    />
                                    <label class="form-check-label" for="defaultCheckg"
                                        >{{ $t("lang.label_slte_all") }}
                                    </label></span
                                >
                            </div>
                            <div>
                                <router-link
                                    :to="{
                                        name: 'Privilegies',
                                        params: { account_id: $route.params.account_id },
                                    }"
                                    class="btn btn-info btn-sm mr-2"
                                    ><i class="fas fa-arrow-left"></i>
                                    {{ $t("lang.label_back") }}</router-link
                                >
                            </div>
                        </div>
                        <div class="card-body" v-if="appDetail.id === 1">
                            <div class="bgloading" v-if="isloading">
                                <Loader></Loader>
                            </div>
                            <form @submit.prevent="UpdatePrivilegies">
                                <div class="row">
                                    <div class="col-md-2">
                                        <ul class="list-group list-group-flush list-priv">
                                            <li class="list-group-item">
                                                <span
                                                    ><b>{{
                                                        $t("lang.label_money_in")
                                                    }}</b></span
                                                >
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="i in moneyinlist"
                                                :key="i.id"
                                            >
                                                <label
                                                    class="form-check-label"
                                                    :for="'defaultCheck' + i.id"
                                                    >{{ i.module_name }}
                                                </label>
                                                <span
                                                    ><input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        v-model="selected"
                                                        :value="i.id"
                                                        :id="'defaultCheck' + i.id"
                                                /></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-2">
                                        <ul class="list-group list-group-flush list-priv">
                                            <li class="list-group-item">
                                                <span
                                                    ><b>{{
                                                        $t("lang.label_money_out")
                                                    }}</b></span
                                                >
                                            </li>

                                            <li
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="i in moneyoutlist"
                                                :key="i.id"
                                            >
                                                <label
                                                    class="form-check-label"
                                                    :for="'defaultCheck' + i.id"
                                                    >{{ i.module_name }}
                                                </label>
                                                <span
                                                    ><input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        v-model="selected"
                                                        :value="i.id"
                                                        :id="'defaultCheck' + i.id"
                                                /></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-2">
                                        <ul class="list-group list-group-flush list-priv">
                                            <li class="list-group-item">
                                                <span
                                                    ><b>{{
                                                        $t("lang.label_customer")
                                                    }}</b></span
                                                >
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="i in customerlist"
                                                :key="i.id"
                                            >
                                                <label
                                                    class="form-check-label"
                                                    :for="'defaultCheck' + i.id"
                                                    >{{ i.module_name }}
                                                </label>
                                                <span
                                                    ><input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        v-model="selected"
                                                        :value="i.id"
                                                        :id="'defaultCheck' + i.id"
                                                /></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-2">
                                        <ul class="list-group list-group-flush list-priv">
                                            <li class="list-group-item">
                                                <span
                                                    ><b>{{
                                                        $t("lang.label_report")
                                                    }}</b></span
                                                >
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="i in reportlist"
                                                :key="i.id"
                                            >
                                                <label
                                                    class="form-check-label"
                                                    :for="'defaultCheck' + i.id"
                                                    >{{ i.module_name }}
                                                </label>
                                                <span
                                                    ><input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        v-model="selected"
                                                        :value="i.id"
                                                        :id="'defaultCheck' + i.id"
                                                /></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-2">
                                        <ul class="list-group list-group-flush list-priv">
                                            <li class="list-group-item">
                                                <span
                                                    ><b>{{
                                                        $t("lang.label_setting")
                                                    }}</b></span
                                                >
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="i in settinglist"
                                                :key="i.id"
                                            >
                                                <label
                                                    class="form-check-label"
                                                    :for="'defaultCheck' + i.id"
                                                    >{{ i.module_name }}
                                                </label>
                                                <span
                                                    ><input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        v-model="selected"
                                                        :value="i.id"
                                                        :id="'defaultCheck' + i.id"
                                                /></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    class="btn btn-success"
                                    style="padding: 2px 5px; margin-top: 10px"
                                >
                                    {{ $t("lang.label_up") }}
                                </button>
                            </form>
                        </div>

                        <div class="card-body" v-if="appDetail.id === 3">
                            <div class="row">
                                <div class="col-md-2">
                                    <ul class="list-group list-group-flush list-priv">
                                        <li class="list-group-item">
                                            <span
                                                ><b>{{
                                                    $t("lang.label_proyect")
                                                }}</b></span
                                            >
                                        </li>
                                        <li
                                            class="list-group-item d-flex justify-content-between"
                                        >
                                            <label
                                                class="form-check-label"
                                                for="defaultCheck1"
                                                >{{ $t("lang.label_Timesheet") }}
                                            </label>
                                            <span
                                                ><input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                            /></span>
                                        </li>
                                        <li
                                            class="list-group-item d-flex justify-content-between"
                                        >
                                            <label
                                                class="form-check-label"
                                                for="defaultCheck2"
                                                >{{ $t("lang.label_labor_orders") }}
                                            </label>
                                            <span
                                                ><input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck2"
                                            /></span>
                                        </li>
                                        <li
                                            class="list-group-item d-flex justify-content-between"
                                        >
                                            <label
                                                class="form-check-label"
                                                for="defaultCheck3"
                                                >{{ $t("lang.label_warranty_list") }}
                                            </label>
                                            <span
                                                ><input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck3"
                                            /></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <button
                                type="button"
                                class="btn btn-success"
                                style="padding: 2px 5px; margin-top: 10px"
                            >
                                {{ $t("lang.label_up") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="noti" position="top center"></notifications>
    </Default-Layout>
</template>

<script>
import axios from "axios";
import Loader from "@/components/shared/Loader";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "PrivilegiesList",
    components: {
        DefaultLayout,
        Loader,
    },
    data () {
        return {
            isloading: false,
            userDetail: null,
            appDetail: null,
            selected: [],
            privilegiesList: [],
            moneyinlist: [],
            moneyoutlist: [],
            customerlist: [],
            reportlist: [],
            settinglist: [],

            //selectAll: false,
        }
    },
    created () {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
        //this.getProfile();
    },
    mounted () {
        console.log("app id load " + this.$route.params.app_id);
        if (this.$route.params.account_id) {
            this.usersById(this.$route.params.account_id);
            this.GetPrivilegies(this.$route.params.account_id);
        }
        if (this.$route.params.app_id) {
            this.AppById(this.$route.params.app_id);
        }
    },
    methods: {
        UpdatePrivilegies() {
            this.isloading = true;
            window.master
                .post("updateprovilegies", {
                    org_id: this.$route.params.org_id,
                    account_id: this.userDetail.account_id,
                    data_apps_ids: this.selected,
                })
                .then((response) => {
                    this.moneyinlist = [];
                    this.moneyoutlist = [];
                    this.customerlist = [];
                    this.reportlist = [];
                    this.settinglist = [];
                    console.log("data responde update privilegies");
                    console.log(response.data);
                    this.isloading = false;
                    this.$notify({
                        group: "noti",
                        title: "¡" + window.lang2.label_up + "!",
                        type: "success",
                        text: window.lang2.msj_upd_sful,
                    });
                    if (this.$route.params.account_id) {
                        this.usersById(this.$route.params.account_id);
                        this.GetPrivilegies(this.$route.params.account_id);
                    }
                })
                .catch((error) => {
                    this.isloading = false;
                    console.log(error);
                });
        },
        usersById(account_id) {
            this.isloading = true;
            window.master
                .get("user/" + window.localAccountID + "/" + account_id)
                .then((response) => {
                    this.userDetail = response.data.user_detail;
                    this.isloading = false;
                })
                .catch((error) => console.log(error));
        },
        GetPrivilegies(account_id) {
            this.isloading = true;
            window.master
                .get("privilegies/" + this.$route.params.org_id + "/" + account_id)
                .then((response) => {
                    console.log("result modules all");
                    console.log(response.data);
                    this.privilegiesList = response.data.result;
                    for (var i = 0; i < this.privilegiesList.length; i++) {
                        if (this.privilegiesList[i].group_id == 1) {
                            // money in
                            this.moneyinlist.push(this.privilegiesList[i]);
                        }
                        if (this.privilegiesList[i].group_id == 2) {
                            // money out
                            this.moneyoutlist.push(this.privilegiesList[i]);
                        }
                        if (this.privilegiesList[i].group_id == 3) {
                            // customer
                            this.customerlist.push(this.privilegiesList[i]);
                        }
                        if (this.privilegiesList[i].group_id == 4) {
                            // report
                            this.reportlist.push(this.privilegiesList[i]);
                        }
                        if (this.privilegiesList[i].group_id == 5) {
                            // setting
                            this.settinglist.push(this.privilegiesList[i]);
                        }
                        if (this.privilegiesList[i].authorized == true) {
                            this.selected.push(this.privilegiesList[i].id);
                        }
                    }
                    this.isloading = false;
                })
                .catch((error) => console.log(error));
        },
        AppById(app_id) {
            console.log("load metohd");
            window.master
                .get("app/" + app_id)
                .then((response) => {
                    this.appDetail = response.data.result;
                    console.log(response.data);
                    this.isloading = false;
                })
                .catch((error) => console.log(error));
        },
    },
    computed: {
        selectAll: {
            get: function () {
                let total =
                    parseInt(this.moneyinlist.length) +
                    parseInt(this.moneyoutlist.length) +
                    parseInt(this.customerlist.length) +
                    parseInt(this.reportlist.length) +
                    parseInt(this.settinglist.length);
                console.log("total = " + total);
                return this.selected.length == total ? true : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.moneyinlist.forEach(function (item) {
                        selected.push(item.id);
                    });
                    this.moneyoutlist.forEach(function (item) {
                        selected.push(item.id);
                    });
                    this.customerlist.forEach(function (item) {
                        selected.push(item.id);
                    });
                    this.customerlist.forEach(function (item) {
                        selected.push(item.id);
                    });
                    this.reportlist.forEach(function (item) {
                        selected.push(item.id);
                    });
                    this.settinglist.forEach(function (item) {
                        selected.push(item.id);
                    });
                }
                this.selected = selected;
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.list-priv {
    .list-group-item {
        padding: 3px;
    }
}
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.profile {
    margin-top: 60px;
}
.profile label {
    display: block;
    margin-bottom: 0.1rem;
}
</style>
